import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, FormControlLabel, Grid, Radio, Stack, Typography } from "@mui/material";
import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { useWatch } from "react-hook-form";
import DisableFormTextField from "../../_components/DisableFormTextField";
import { InvoiceType } from "../../../../types";
import { FormRadioGroup } from "../../../../components/fields";
import { IFormValues } from "../../types";

const BillingOwner = () => {
    const { t } = useTranslation('booking');

    const billingOwner = useWatch<IFormValues, 'billingOwner'>({
        name: 'billingOwner'
    });

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                    <Typography variant="h5">
                        {t('label.billingOwner')}
                    </Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    <Grid item xs={12}>
                        <FormRadioGroup<IFormValues>
                            name="billingOwner.type"
                            label=""
                            readOnly={true}
                        >
                            <FormControlLabel
                                value={InvoiceType.PERSON}
                                label={t("label.person")}
                                control={<Radio />}
                            />
                            <FormControlLabel
                                value={InvoiceType.VAT_NUMBER_HOLDER}
                                label={t("label.vatNumberHolder")}
                                control={<Radio />}
                            />
                            <FormControlLabel
                                value={InvoiceType.COMPANY}
                                label={t("label.company")}
                                control={<Radio />}
                            />
                        </FormRadioGroup>
                    </Grid>


                    { billingOwner?.type !== InvoiceType.PERSON &&
                        <>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.id" label={'label.id'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.legalEntity" label={'label.legalForm'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.companyName" label={'label.companyName'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.fiscalCode" label={'label.fiscalCode'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.email" label={'label.email'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.billingCountry" label={'label.billingCountry'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.billingProvince" label={'label.billingProvince'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.billingCity" label={'label.placeOfBirth'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.billingStreetName" label={'label.billingStreetName'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.billingStreetNumber" label={'label.billingStreetNumber'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.billingPostalCode" label={'label.billingPostalCode'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.certifiedEmailAddress" label={'label.certifiedEmailAddress'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.invoiceCode" label={'label.invoiceCode'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.vatNumberCountry" label={'label.vatNumberCountry'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="billingOwner.vatNumber" label={'label.vatNumber'}/>
                            </Grid>
                        </>
                    }
                    { billingOwner?.type === InvoiceType.PERSON &&
                        <>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.id" label={'label.id'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.firstName" label={'label.firstName'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.lastName" label={'label.lastName'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.birthDate" label={'label.birthDate'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.birthNation" label={'label.nationOfBirth'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.birthPlace" label={'label.birthPlace'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.birthPlace" label={'label.birthPlace'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.residenceCountry" label={'label.countryOfResidence'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.fiscalCode" label={'label.fiscalCode'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.email" label={'label.email'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.mobilePrefix" label={'label.prefix'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.mobile" label={'label.mobile'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.drivingLicenseNumber" label={'label.drivingLicenseNumber'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.billingCountry" label={'label.billingCountry'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.billingProvince" label={'label.billingProvince'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.billingCity" label={'label.billingCity'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.billingStreetName" label={'label.billingStreetName'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.billingStreetNumber" label={'label.billingStreetNumber'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.billingPostalCode" label={'label.billingPostalCode'}/>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <DisableFormTextField name="billingOwner.certifiedEmailAddress" label={'label.certifiedEmailAddress'}/>
                                </Grid>
                        </>
                    }
                </Grid>
            </AccordionDetails>
        </Accordion >
    )
}

export default BillingOwner;
